module.exports = "/remote-dist/3b266347586910722a2aaf53acf6f934.png";